import styled from 'styled-components';

export const ActionColumn = styled.div`
  display: flex;

  button {
    margin: 0 4px;
  }
`;
